import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { TIME_TO_REFETCH } from "utils/guards";
// import { delay, fetchConfig } from "utils";

const useGuards = () => {
	const { accessToken } = useTokenStore();

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("/guards");
		return res?.data?.data;
	};

	// const TIME_TO_REFETCH = 5000;

	return useQuery(["guards"], () => fetch(), {
		// cacheTime: TIME_TO_REFETCH,
		// staleTime: TIME_TO_REFETCH,
		retry: 1,
		refetchInterval: TIME_TO_REFETCH,
		refetchIntervalInBackground: true,
	});
};

export default useGuards;
